import { useSelector } from 'react-redux';
import useTranslation from '../../../../hooks/useTranslations';
import { selectFeaturedObjectsForBusinessAreaId } from '../../../../redux/modules/data/businessAreasSlice';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import ObjectTile from '../partials/tiles/ObjectTile';
import TileWrapper from '../partials/TileWrapper';
import FeaturedObjectsSlider from './partials/FeaturedObjectsSlider';
import YellowMenu from './partials/YellowMenu';

const BusinessAreaScreen = ({ activeTree }) => {
	const featuredItems = useSelector((state) => selectFeaturedObjectsForBusinessAreaId(state, activeTree.businessArea.id));

	const t = useTranslation();

	if (activeTree.businessArea) {
		return (
			<>
				{featuredItems && <FeaturedObjectsSlider featuredItems={featuredItems} />}
				{(activeTree.businessArea.evaluationAppFolderId || activeTree.businessArea.yellowMenuFolderId) && <YellowMenu activeTree={activeTree} />}
				<ContentWrapper title={t(activeTree.businessArea.translationkey)} thumb={activeTree.businessArea.image}>
					<>
						{featuredItems && (
							<div className="block lg:hidden">
								<div className="flex justify-center">
									<h1 className="px-3 pt-6 pb-2 text-[1.5625rem] text-oly-gray-darkest">
										{/* TODO: Get transKey from data (BA -> moreInfoBox -> translationkey) */}
										{t('dyn_nabo_more_information#')}
									</h1>
								</div>
								<TileWrapper containerClasses="pt-2">
									{featuredItems.map((object) => <ObjectTile key={object.id} object={object} />)}
								</TileWrapper>
							</div>
						)}
					</>
				</ContentWrapper>
			</>
		);
	}

	return null;
};

export default BusinessAreaScreen;
